import React from 'react';
import { Line, LineChart, ResponsiveContainer, YAxis } from 'recharts';
import { styled, useTheme } from '@mui/material';

export interface TinyLineChartProps {
  type: 'tinyLineChart';
  data: Record<string, number>;
  dataName: string;
  color?: string;
  size?: {
    width: number;
    height: number;
  };
}

type DataPoint = {
  name: string;
  [key: string]: number | string;
};

const TinyLineChart: React.FC<TinyLineChartProps> = ({ color, data, dataName, size = { width: 200, height: '100%' } }) => {
  const theme = useTheme();
  const defaultColor = color ?? theme.palette.primary.main;

  const formattedData: DataPoint[] = Object.entries(data).map(([k, v]) => ({
    name: k,
    [dataName]: v,
  }));

  const values = formattedData.map((d) => d[dataName] as number);
  const min = Math.min(...values);
  const max = Math.max(...values);

  return (
    <ResponsiveContainerCustomer width={size.width} height={size.height}>
      <LineChart data={formattedData}>
        <YAxis domain={[min, max]} hide />
        <Line key={dataName} type="monotone" dataKey={dataName} strokeWidth={3} dot={false} stroke={defaultColor} />
      </LineChart>
    </ResponsiveContainerCustomer>
  );
};

export default TinyLineChart;

const ResponsiveContainerCustomer = styled(ResponsiveContainer)(({ theme }) => ({
  minHeight: 20,
  marginLeft: theme.spacing(2.5),
  '&>div': { overflow: 'visible!important' },
}));
